// extracted by css-extract-rspack-plugin
export default {"actionsCell":"actionsCell-h3uj6C","buttonContainer":"buttonContainer-w8MhLF","actionButton":"actionButton-EAThqN"};